import { v as viewport } from '../enums-Dx-SbKu4.js';
import { g as getViewportRect } from './getViewportRect-BlJjVXu2.js';
import { g as getDocumentRect } from './getDocumentRect-gL9bXwKJ.js';
import { l as listScrollParents } from './listScrollParents-kV1o53CP.js';
import { g as getOffsetParent } from './getOffsetParent-BbHxVI4G.js';
import { g as getDocumentElement } from './getDocumentElement-CF55JRdX.js';
import { g as getComputedStyle } from './getComputedStyle-cPuW_mTw.js';
import { b as isHTMLElement, i as isElement } from './instanceOf-DT24G-dX.js';
import { g as getBoundingClientRect } from './getBoundingClientRect-DDQmpYPm.js';
import { g as getParentNode } from './getParentNode-R596COVt.js';
import { c as contains } from './contains-DNes4CjY.js';
import { g as getNodeName } from './getNodeName-B4zdFol3.js';
import { r as rectToClientRect } from '../utils/rectToClientRect-BePxUN7v.js';
import { m as max, a as min } from '../utils/math-DYbrqK2d.js';

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

export { getClippingRect as g };
//# sourceMappingURL=getClippingRect-Ch1Vvq5g.js.map
